(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    var nav         = document.getElementById('cr-main-nav');
    var list        = document.getElementById('cr-main-nav-list');
    var overflowBtn = document.getElementById('cr-nav-overflow-btn');
    if (!nav || !list || !overflowBtn) return;

    var HYSTERESIS = 40;
    var overflowing = false;

    function checkOverflow() {
      if (!overflowing && list.scrollWidth > list.clientWidth + HYSTERESIS) {
        overflowing = true;
        overflowBtn.hidden = false;
      } else if (overflowing && list.scrollWidth <= list.clientWidth - HYSTERESIS) {
        overflowing = false;
        overflowBtn.hidden = true;
      }
    }

    window.addEventListener('resize', checkOverflow);
    checkOverflow();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["top-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var inner = document.getElementById('cr-topbar-inner');
    if (!inner) return;
    var items = inner.querySelectorAll('.cr-topbar__item');
    if (items.length < 2) return;

    var isMobile = function () { return window.innerWidth < 768; };
    var current = 0;

    function rotate() {
      if (!isMobile()) return;
      items[current].classList.remove('cr-topbar__item--active');
      current = (current + 1) % items.length;
      items[current].classList.add('cr-topbar__item--active');
    }

    setInterval(rotate, 7000);
  })();
  } catch(e) { console.error(e); }
})();

})();
